export default {
  title: {
    id: 'address_book_rules_address_title',
    defaultMessage: 'Select an address for this rule',
  },
  cta: {
    id: 'address_book_rules_cta',
    defaultMessage: 'Save and continue',
  },
}
